import { render, staticRenderFns } from "./manage-cookies.vue?vue&type=template&id=723a146a&"
import script from "./manage-cookies.vue?vue&type=script&lang=js&"
export * from "./manage-cookies.vue?vue&type=script&lang=js&"
import style0 from "./manage-cookies.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "manage-cookies.vue"
export default component.exports